
import ApplicationController from "./application_controller";
import StimulusReflex from "stimulus_reflex";

export default class extends ApplicationController {
  static targets = [
    "select",
    "sortable",
    "searchresults",
    "item",
    "category",
    "orderbutton",
    "filterinput",
  ];

  connect() {
    super.connect();
    StimulusReflex.register(this);

    this.order = super.getCookie("sortorder");
    this.orderBy = super.getCookie("sortOrderBy");

    if (!this.order) {
      super.setCookie("sortorder", 1);
      this.order = 1;
    }
    if (!this.orderBy) {
      super.setCookie("sortOrderBy", this.selectTarget.value);
      this.orderBy = this.selectTarget.value;
    } else {
      this.selectTarget.value = this.orderBy;
    }


    this.sort();

    document.cookie = "sortorder=" + this.order;
  }

  sort(e) {
    let button = e ? e.target.closest("button") : this.orderbuttonTargets[0];
    this.selectTarget.value = button.dataset.sortby;

    button.dataset.sortorder = button.dataset.sortorder ? (button.dataset.sortorder * -1) : 1;
    this.order = button.dataset.sortorder;

    this.activateOrderButton(button);
    this.updateOrderButtonIcon(button);

    this.sortableTargets.forEach(function (sortableTarget) {
      this.sortElement(sortableTarget, Array.from(sortableTarget.querySelectorAll('[data-sorter-target="item"]')));
    }.bind(this));

    this.addTabIndexes();
  }
  addTabIndexes() {
    let items = Array.from(document.querySelectorAll('[data-sorter-target="item"]'))
    for (let i = 0; i < items.length; i++) {
      let a = items[i].querySelector("a");
      if (a) a.setAttribute("tabindex", i+1); // set the tabindex
    };
  }
  sortElement(tb, tr) {
    var i;

    this.orderBy = this.selectTarget.value;
    // console.log("sorting items: " + tr.length + " by " + this.orderBy);
    super.setCookie("sortOrderBy", this.orderBy);

    var reverse = this.order;
    console.log(" sort in order " + reverse)
    // reverse = -((+reverse) || -1);
    if (!Array.isArray(tr)) {
      return true;
    }
    tr = tr.sort(
      function (a, b) {
        // sort rows
        let compa = a.querySelector(
            '[data-sorter-category="' + this.orderBy + '"]',
          ).dataset.sorterValue,
          compb = b.querySelector(
            '[data-sorter-category="' + this.orderBy + '"]',
          ).dataset.sorterValue;

        // console.log("compare ", compa, compb);
        if (compa != undefined) {
          return reverse * compa.localeCompare(compb);
        }
        return (
          reverse *
          a
            .querySelector('[data-sorter-category="' + this.orderBy + '"]')
            .textContent.trim()
            .localeCompare(
              b
                .querySelector('[data-sorter-category="' + this.orderBy + '"]')
                .textContent.trim(),
            )
        );
      }.bind(this),
    );
    for (i = 0; i < tr.length; ++i) {
      tb.appendChild(tr[i]); // append each row in order
    }
  }

  toggleOrder() {
    this.order = this.order * -1;
    super.setCookie("sortorder", this.order);
    this.updateOrderButtonIcon();
    this.sort();
  }
  activateOrderButton(button) {
    this.orderbuttonTargets.forEach((button) => {
      button.classList.remove("sorter-active");
      button.classList.add("sorter-inactive");
      let icon = button.querySelector("i");
      if (icon) icon.remove();
    });
    button.classList.add("sorter-active");
    button.classList.remove("sorter-inactive");
  }
  updateOrderButtonIcons() {
    this.orderbuttonTargets.forEach((button) => {
      this.updateOrderButtonIcon(button);
    });
  }
  updateOrderButtonIcon(button) {

    if(button.dataset.sortorder == 1) {
      button.innerHTML += '<i class="bi bi-arrow-down-square mx-2"></i>';
      button.dataset.title = "Aufsteigend sortiert";
    } else {
      button.innerHTML += '<i class="bi bi-arrow-up-square mx-2"></i>';
      button.dataset.title = "Absteigend sortiert";
    }
  }

  async updateSearch(e) {
    let filterValue = e.target.value.toUpperCase().trim();

    console.log("filter by: " + filterValue);

    if (filterValue == "" || filterValue.length < 1) {
      // console.log("\tdo not filter");
      this.showSortableTargets();
      this.searchresultsTarget.classList.add("d-none");
      return true;
    }

    await super.sleep(500);
    this.filter(e);
  }

  hideSortableTargets() {
    this.sortableTargets.forEach(function(st) {
      st.classList.add("d-none");
    })
  }

  showSortableTargets() {
    this.sortableTargets.forEach(function(st) {
      st.classList.remove("d-none");
    })
  }

  async filter(e) {
    let filterValue = e.target.value.toUpperCase().trim();
    var counter = 0;

    // this.itemTargets.forEach(function (el, key, listObj) {
    //   let txtValue = el.textContent || el.innerText;
    //   // console.log(`Element ${el}:  ${txtValue} \n`);
    //   if (txtValue.toUpperCase().indexOf(filterValue) > -1) {
    //     el.style.display = "";
    //     counter++;
    //   } else {
    //     el.style.display = "none";
    //   }
    // }, "arg");

    let headers = {
      "Content-Type": "application/json",
      Accept: "text/html",
      "X-Requested-With": "XMLHttpRequest",
      authenticity_token: this.getCsrfToken(),
    };

    let res = await super.doFetch(
      "/board_containers/search",
      "POST",
      JSON.stringify({
        authenticity_token: this.getCsrfToken(),
        filterValue: e.target.value,
      }),
      headers,
    );
    if (res.ok) {
      let html_text = await res.text();
      // console.log("html: " + html_text);

      if (document.querySelector("#createfirst") != undefined) {
        document.querySelector("#createfirst").classList.add("d-none");
      }

      this.hideSortableTargets();
      this.searchresultsTarget.classList.remove("d-none");

      this.searchresultsTarget.innerHTML = html_text;
      // console.log(this.searchresultsTarget.innerHTML);
      let searchItems = this.searchresultsTarget.querySelectorAll("li");
      if (searchItems != undefined) {
        this.sortElement(this.searchresultsTarget, searchItems);
      }
    }
  }
}
